<script setup lang="ts">
import AppCard from '@/components/card/AppCard.vue'
import { version } from '~/package.json'
import { Page } from '~/types/types'
useSeoMeta({
  title: () => `Drivmedla - Om Drivmedla`,
  description: () =>
    'Läs på om vad Drivmedla är, vad det fyller för syfte samt vilka initiativtagarna är.',
  ogTitle: () => `Drivmedla - Om Drivmedla`,
  ogDescription: () =>
    'Läs på om vad Drivmedla är, vad det fyller för syfte samt vilka initiativtagarna är.',
  ogLocale: () => 'sv_SE',
  ogSiteName: () => 'Drivmedla',
  ogUrl: () => `${useRuntimeConfig().public.baseURL}${useRoute().fullPath}`,
  ogImage: () => `${useRuntimeConfig().public.baseURL}/_nuxt/assets/_logo-horizontal-GREEN.svg`,
})
const { findOne } = useStrapi()
const { data: pageInfo } = await useAsyncData(
  'about-page',
  () => findOne<Page>('about-page', { populate: '*' }),
  { transform: (_pageInfo) => _pageInfo.data }
)
</script>
<template>
  <div>
    <AppHero
      :title="pageInfo?.attributes.generalContent.title"
      :description="pageInfo?.attributes.generalContent.ingress"
    />
    <LayoutSection>
      <div class="flex justify-content-center my-6">
        <div class="col-12 sm:col-12 md:col-10 lg:col-7">
          <AppCard>
            <MarkdownRenderer
              v-if="pageInfo?.attributes.generalContent.richText"
              :content="pageInfo?.attributes.generalContent.richText"
            />
            <img class="eu-logo" src="~/assets/EU-logo.png" alt="EU logotyp" />
            <h3>Projektdeltagare</h3>
            <img src="~/assets/Logos.jpg" alt="ReDriv partnerorganisationer" />
          </AppCard>
          <div class="version">V{{version}}</div>
        </div>
      </div>
    </LayoutSection>
  </div>
</template>
<style scoped lang="scss">
.version {
  text-align: center;
  color: #999;
  margin-top: 1rem;
}
.eu-logo {
  width: 270px;
  margin-top: 1rem;
}
</style>
